export enum PERMISSIONS {
  FREE = 0,
  VIP = 1,
  NORMAL = 2,
};

export const PERMISSION_MAP = {
  [PERMISSIONS.FREE]: '免费',
  [PERMISSIONS.VIP]: 'VIP权限',
  [PERMISSIONS.NORMAL]: '普通权限',
};

export const PERMISSION_TAG_COLOR = {
  [PERMISSIONS.FREE]: 'green',
  [PERMISSIONS.VIP]: 'gold',
  [PERMISSIONS.NORMAL]: 'default',
}

export enum STATUS {
  INUSE = 2,
  DISABLE = 1,
}

export const STATUS_MAP = {
  [STATUS.INUSE]: '上架',
  [STATUS.DISABLE]: '下架',
}

export const STATUS_WORDS_MAP = {
  [STATUS.INUSE]: '是',
  [STATUS.DISABLE]: '否',
}

export const STATUS_TAG_COLOR = {
  [STATUS.INUSE]: 'success',
  [STATUS.DISABLE]: 'error',
}

export enum ROLES {
  SPEAKER_A = 1,
  SPEAKER_B = 2,
}

export const ROLE_MAP = {
  [ROLES.SPEAKER_A]: '角色A(男)',
  [ROLES.SPEAKER_B]: '角色B(女)',
};